<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mx-auto">
          <v-card-text>
            Hidden:
            <v-checkbox v-model="hidden"></v-checkbox>
            Text:
            <v-text-field v-model="text" placeholder="Text" required></v-text-field>
            Priority:
            <v-text-field v-model="priority" placeholder="Priority" required></v-text-field>
            Categories:
            <v-autocomplete
              v-model="selectedCategories"
              :items="info.categories"
              chips
              item-text="text"
              item-value="id"
              multiple
            >
              <template v-slot:append>
                <v-icon color="#428751">mdi-arrow-down-drop-circle</v-icon>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeCategory(data.item)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-btn color="success" class="mr-4" @click="saveTag()"> Save </v-btn>

            <v-dialog v-if="tagId" v-model="dialog" persistent max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="error" class="mr-4" v-bind="attrs" v-on="on"> Delete </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline"> Delete tag? </v-card-title>
                <v-card-text>This operation can not be undone</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" class="mr-4" text @click="((dialog = false), deleteTag())"> Delete </v-btn>
                  <v-btn color="green darken-1" text @click="dialog = false"> Cancel </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-text>
          <v-alert v-if="error" type="error">
            {{ error }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// Import Vue FilePond

/* eslint-disable no-debugger */

import API from '../../api';

/* eslint-disable-next-line  */

export default {
  name: 'Profile',
  props: {
    tagId: {
      type: [String]
    }
  },

  components: {},

  data: () => ({
    error: null,
    info: {},
    categories: {},
    selectedCategories: [],
    text: '',
    priority: 0,
    hidden: false,
    sent: false,
    dialog: false
  }),
  mounted() {
    document.title = 'Admin Tag';
  },
  //LOAD
  created: async function () {
    this.error = null;
    let res = await API.get('admin/tag?tagId=' + encodeURI(this.tagId));
    if (!res) {
      return;
    }
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      this.error = null;
      this.info = res.data.info;
      if (this.info.tag) {
        this.text = this.info.tag.text;
        this.hidden = this.info.tag.hidden;
        this.priority = this.info.tag.priority;
        if (this.info.tag.TagCategories) {
          this.selectedCategories = this.info.tag.TagCategories.map(tagCategory => tagCategory.categoryId);
        }
      }

      for (let index = 0; index < res.data.info.categories.length; index++) {
        const category = res.data.info.categories[index];
        this.categories[category.id] = category;
      }
    }
  },
  computed: {},
  methods: {
    removeCategory(item) {
      const index = this.selectedCategories.indexOf(item.id);
      if (index >= 0) this.selectedCategories.splice(index, 1);
    },
    async saveTag() {
      let res = await API.post('admin/tag', {
        tagId: this.tagId,
        text: this.text,
        priority: this.priority,
        categories: this.selectedCategories,
        hidden: this.hidden
      });
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
        this.sent = false;
      } else {
        this.error = null;
        this.sent = true;
        this.$router.push('/admin/tags');
      }
    },
    async deleteTag() {
      let res = await API.delete('admin/tag', {
        tagId: this.tagId
      });
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
        this.sent = false;
      } else {
        this.error = null;
        this.sent = true;
        this.$router.push('/admin/tags');
      }
    }
  }
};
</script>

<style></style>
